import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { RouteComponentProps } from 'react-router';
import { OurRoute } from "./OurRoute";

export default class RouteHP extends OurRoute {

    constructor(props, context) {
        super(props, context);

    }


    render() {
        //
        if (this.props.computedMatch) {
            //debugger;
            if (typeof window === 'undefined') {
                return super.render();
            }
            else {
                const serverData = window.serverData.data;  // we can assume the window object here because we won't 
                //debugger;
                //window.store.persist();
                if (!window.location.host.toLowerCase().startsWith("localhost") && window.location.host !== serverData.hpDomain) {
                    window.persistor.flush();
                    //window.setTimeout(() => {
                    window.location.host = serverData.hpDomain;
                    //}, 100);
                    
                    return "";
                }
                else {
                    return super.render();
                }
            }
        }
        else {
            return "";
        }
    }

}


